jQuery(document).ready(function ($) {

    if ( $(document).width() < 461 ) {
        $('.vendor-page-products .all-vendors__heading').click(() => {
            $('.vendor-page-products .all-vendors__content').fadeIn();
        });
    }

    $('.vendor-page-products .all-vendors__heading-mob .close-modal, .all-vendors-close span').click(() => {
        $('.vendor-page-products .all-vendors__content').fadeOut();
    });

});